/**
 * Query-param contract for `GET /search/city/{citySlug}`.
 * Keep the URL params the UI writes and the API params in one place so the two
 * can't drift again.
 */
export const SEARCH_PARAMS = {
  CHECK_IN: "checkIn",
  CHECK_OUT: "checkOut",
  CAPACITY: "capacity",
  TYPE: "type",
  AMENITY: "amenity",
  ORIGIN: "origin",
  LOWER_PRICE: "lowerRangePrice",
  UPPER_PRICE: "upperRangePrice",
  HAS_DISCOUNT: "hasDiscount",
  IS_INSTANT_BOOKABLE: "isInstantBookable",
  MIN_RATING: "minOverallRating",
  SORT_BY: "sortBy",
  PAGE: "page",
  LIMIT: "limit",
} as const;

/** Every filter param the PLP owns — used to reset/rebuild the query string. */
export const FILTER_PARAM_KEYS: string[] = [
  SEARCH_PARAMS.CAPACITY,
  SEARCH_PARAMS.TYPE,
  SEARCH_PARAMS.AMENITY,
  SEARCH_PARAMS.ORIGIN,
  SEARCH_PARAMS.LOWER_PRICE,
  SEARCH_PARAMS.UPPER_PRICE,
  SEARCH_PARAMS.HAS_DISCOUNT,
  SEARCH_PARAMS.IS_INSTANT_BOOKABLE,
  SEARCH_PARAMS.MIN_RATING,
];

/** Allowed `sortBy` values — same keys the UI tabs write to `?sort=`. */
export const SORT_VALUES = ["popular", "cheapest", "expensive"] as const;
export type SortValue = (typeof SORT_VALUES)[number];

export const DEFAULT_SORT: SortValue = "popular";
export const DEFAULT_PAGE_SIZE = 12;

/** Maps the UI `sort` param to the API `sortBy` param (now 1:1). */
export const toApiSortBy = (sort: string | undefined): SortValue => {
  const value = (sort ?? DEFAULT_SORT) as SortValue;
  return SORT_VALUES.includes(value) ? value : DEFAULT_SORT;
};

/** Rating thresholds offered in the filter drawer when the API gives none. */
export const DEFAULT_RATING_THRESHOLDS = [3, 3.5, 4, 4.5];
